import { Transform } from "../../../geometry/transformation";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { endRubberline } from "../../../store/interaction";
import { insertShape } from "../../../store/model";
import { RootState } from "../../../store/store";
import { getShapeTransfomer } from "../util/shapeCategorySingleton";

const TextRubber = () => {

  const dispatch = useAppDispatch();
  const interaction = useAppSelector((state: RootState) => state.interaction)
  const defaultSetting = useAppSelector((state: RootState) => state.tool.toolSettings.text.default);
  // const mousePositionSnap = useAppSelector((state: RootState) => state.interface.mousePositionSnap);
  const mousePosition = useAppSelector((state: RootState) => state.interface.mouseUnmodifiedPosition);

  const trans = Transform.translationTransform(mousePosition.x, mousePosition.y)
  const internalProperties = {
    ...defaultSetting,
    id: 0,
    transformation: trans.m,
  }

  if (interaction.rubberlineData.snapPoints.length === 1) {

    const newProps = {
      ...internalProperties,
    }


    dispatch(insertShape({ ...newProps, id: 0, snapPoint: getShapeTransfomer(newProps.type)?.snapPointCalculator(newProps).snapPoint }))
    dispatch(endRubberline());
  }
  return <></>
}
const createTextRubber = () => {
  return (
    <TextRubber />
  )
}
export { createTextRubber };
export default TextRubber; 